<template>
    <v-layout justify-center row>
        <v-dialog
                :item="item"
                @input="close"
                v-model="show"
                width="800">

            <v-toolbar color="primary">
                <v-toolbar-title class="white--text">
                    Angelegte Accounts von <strong>{{ item.name }}</strong>
                </v-toolbar-title>
                <v-spacer/>
                <v-btn @click="close" color="white" icon>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <v-container fluid style="background-color: lightgrey" v-if="item.users">
                <v-layout align-center justify-center>
                    <v-flex>
                        <v-card>
                            <v-data-table :headers="headers"
                                          :items="item.users"
                                          :options="{
                                              itemsPerPage: -1,
                                              sortBy: ['created_at'],
                                              sortDesc: [true]
                                          }"

                                          class="elevation-1">

                                <template v-slot:item.created_at="{ item }">
                                    <span>{{ formatServerTimestamp(item.created_at) }}</span>
                                </template>

                            </v-data-table>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-dialog>
    </v-layout>
</template>

<script>
    import AccountInfoStore from "../../ts/stores/AccountInfoStore";
    import TimeUtility from "@/utils/time";

    export default {
        name: "AccountInfoDialog",

        data() {
            return {
                state: AccountInfoStore.state,
                show: false,
                headers: [
                    {
                        text: 'Mandatenname',
                        align: 'center',
                        value: 'name'
                    },
                    {
                        text: 'Erstellungsdatum',
                        align: 'center',
                        value: 'created_at'
                    }
                ]
            }
        },
        props: {
            value: Boolean,
            item: {}
        },
        watch: {
            state: {
                handler() {
                    this.show = this.state.dialogVisible;
                },
                deep: true
            },
            show(val) {
                if (!val) {
                    this.close()
                }
            }
        },
        methods: {
            close() {
                AccountInfoStore.dismiss()
            },
            formatServerTimestamp(date) {
                return TimeUtility.formattedDate(date)
            }
        }
    }
</script>
